module.exports = __webpack_public_path__ + "static/media/facebook.8d25ee95.svg";